import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-opportunite',
  templateUrl: './opportunite.component.html',
  styleUrls: ['./opportunite.component.css']
})
export class OpportuniteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
